import { openSettings } from 'expo-linking';
import { useRouter } from 'expo-router';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import IconButton from 'shared/components/vxl/icon/IconButton/IconButton';
import { IllustrationKeyType } from 'shared/components/vxl/Illustration/Illustration';
import ActionScreen from 'shared/patterns/vxl/ActionScreen/ActionScreen';
import theme from 'shared/styles/theme';

export interface PermissionDisabledScreenProps {
  titleText: string;
  contentList: string[];
  primaryButtonText: string;
  visual: IllustrationKeyType;
  visualAccessibilityLabel: string;
  onClose?: () => void;
}

const PermissionDisabledScreen = ({
  titleText,
  contentList,
  primaryButtonText,
  visual,
  visualAccessibilityLabel,
  onClose,
}: PermissionDisabledScreenProps) => {
  const router = useRouter();
  const insets = useSafeAreaInsets();

  const handlePrimaryAction = async () => {
    await openSettings();
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      router.back();
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <View style={[styles.header, { paddingTop: insets.top }]}>
        <TouchableOpacity onPress={handleClose} style={styles.closeButton}>
          <IconButton
            iconButtonAccessibilityLabel="CLOSE"
            iconKey="CLOSE"
            iconOnPress={handleClose}
          />
        </TouchableOpacity>
      </View>
      <ActionScreen
        titleText={titleText}
        titleTextStyle="extra-large"
        visual={visual}
        visualAccessibilityLabel={visualAccessibilityLabel}
        bodyContent={
          <View style={styles.bodyContainer}>
            <ContentList contentList={contentList} />
          </View>
        }
        primaryButton={{
          label: primaryButtonText,
          onPress: handlePrimaryAction,
        }}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    rowGap: theme.spacing.m,
  },
  closeButton: {
    backgroundColor: 'transparent',
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  header: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
});

export default PermissionDisabledScreen;
